import axios from 'axios/index'
import Vue from 'vue'
import store from '../store'

axios.defaults.baseURL = process.env.VUE_APP_API

Vue.prototype.$http = axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

var numberOfAjaxCAllPending = 0;

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  numberOfAjaxCAllPending++;
  store.dispatch('setLoader', true)
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  numberOfAjaxCAllPending--;

  if (numberOfAjaxCAllPending == 0) {
    store.dispatch('setLoader', false)
  }
  return response;
}, function (error) {
  numberOfAjaxCAllPending--;
  if (numberOfAjaxCAllPending == 0) {
    store.dispatch('setLoader', false)
  }
  return Promise.reject(error);
});
